import FontAwesomeIcon from '@/componentv2/fontAwesomeIcon/fontAwesomeIcon';
import Typography from '@/componentv2/typography/typography';

interface QuoteBlockProps {
  quote?: string | null;
  author?: string | null;
  style?: string;
  name?: string;
  backgroundColor?: string;
}

export default function QuoteBlock({
  quote,
  author,
  style,
  name,
  backgroundColor,
}: QuoteBlockProps) {
  return (
    <>
      {quote && (
        <div
          className="features-quote-content"
          style={{
            backgroundColor: backgroundColor || 'transparent',
          }}
        >
          {name && <FontAwesomeIcon style={style || ''} name={name} />}
          <Typography style="quote">{quote}</Typography>
          <Typography style="quote-attribution">{author}</Typography>
        </div>
      )}
    </>
  );
}
